<template>
    <b-form>
        <b-row>
            <!-- Left column: Expiry Days -->
            <b-col md="6">
                <label class="font-weight-bold"
                    >Review Expiry Days &nbsp;<i
                        id="button-1"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                    >
                        <b-tooltip
                            target="button-1"
                            placement="topright"
                            triggers="hover"
                            >The Review Expiry Days setting allows sellers to
                            define a time limit for customers to submit ratings
                            and reviews after an item has been
                            delivered.</b-tooltip
                        >
                    </i>
                </label>

                <b-input-group>
                    <b-form-input
                        id="expiry-days"
                        type="number"
                        v-model="expiryDays"
                        @input="setConfig"
                    />
                </b-input-group>
            </b-col>

            <!-- Right column: Toggles -->
            <b-col md="6">
                <div
                    class="d-flex align-items-center border rounded-sm px-2 card-height"
                >
                    <span class="font-weight-bold"
                        >Review Approval &nbsp;<i
                            id="button-2"
                            class="fas fa-question-circle"
                            style="color: #727cf5"
                        >
                            <b-tooltip
                                target="button-2"
                                placement="topright"
                                triggers="hover"
                                >This feature allows sellers to manually approve
                                customer reviews before they are
                                published.</b-tooltip
                            >
                        </i>
                    </span>
                    <v-switch
                        color="green"
                        v-model="reviewApproval"
                        @change="setConfig"
                    ></v-switch>
                </div>
                <div
                    class="d-flex align-items-center border rounded-sm px-2 pb-0 mt-2 card-height"
                >
                    <span class="font-weight-bold"
                        >Foul Language &nbsp;<i
                            id="button-3"
                            class="fas fa-question-circle"
                            style="color: #727cf5"
                        >
                            <b-tooltip
                                target="button-3"
                                placement="topright"
                                triggers="hover"
                                >If enabled, AI will automatically block
                                customer reviews that contain abusive or
                                inappropriate words before
                                submission.</b-tooltip
                            >
                        </i>
                    </span>
                    <v-switch
                        color="green"
                        v-model="foulLanguage"
                        @change="setConfig"
                    ></v-switch>
                </div>
            </b-col>
        </b-row>

        <!-- Notification references -->
        <div class="mt-4 border rounded-sm p-3">
            <div>
                <span class="font-weight-bold"
                    >Notification preference for rating &nbsp;<i
                        id="button-4"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                    >
                        <b-tooltip
                            target="button-4"
                            placement="topright"
                            triggers="hover"
                            >Sellers can enable WhatsApp, SMS, Email, or In-App
                            notifications to remind customers to submit a review
                            after delivery, with a direct link
                            included.</b-tooltip
                        >
                    </i></span
                >
            </div>
            <div class="mt-2 border rounded-sm p-3">
                <b-form-group
                    label="Select Notification preference for rating"
                    label-class="font-weight-bold"
                >
                    <b-row>
                        <b-col
                            lg="6"
                            class="mb-3"
                            v-for="(method, index) in notificationMethods"
                            :key="method.id"
                        >
                            <div
                                class="d-flex flex-row align-items-center px-2 border rounded-sm"
                            >
                                <div style="height: 32px; width: 32px">
                                    <img
                                        :src="method.icon"
                                        :alt="method.label"
                                        width="32"
                                        height="32"
                                        class="mr-2"
                                    />
                                </div>
                                <span class="flex-grow-1">{{
                                    method.label
                                }}</span>
                                <v-switch
                                    color="green"
                                    v-model="method.enabled"
                                    @change="setConfig"
                                ></v-switch>
                            </div>
                        </b-col>
                    </b-row>
                </b-form-group>
            </div>
        </div>
    </b-form>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
    name: "RatingReviewPreference",

    components: {},
    data() {
        return {
            expiryDays: 0,
            reviewApproval: false,
            foulLanguage: false,
            notificationMethods: [
                {
                    id: "whatsapp",
                    label: "WhatsApp",
                    icon: require("@/assets/images/whatsapp.png"),
                    enabled: false,
                },
                {
                    id: "email",
                    label: "Email",
                    icon: require("@/assets/images/email.png"),
                    enabled: false,
                },
                {
                    id: "sms",
                    label: "SMS",
                    icon: require("@/assets/images/sms.png"),
                    enabled: false,
                },
                {
                    id: "inapp",
                    label: "InApp",
                    icon: require("@/assets/images/inapp.png"),
                    enabled: false,
                },
            ],
        };
    },
    computed: {
        ...mapState({
            partnerConfig: (state) => state.partner.partnerConfig,
        }),
    },
    methods: {
        async setConfig() {
            try {
                const social = {};
                for (const obj of this.notificationMethods) {
                    social[obj.id] = obj.enabled;
                }
                const payload = {
                    reviewApproval: this.reviewApproval,
                    reviewExpiryDay: parseInt(this.expiryDays),
                    foulLanguage: this.foulLanguage,
                    ...social,
                    partner: this.$route.params.id,
                };
                await this.$store.dispatch(
                    "partner/setPartnerConfigAction",
                    payload,
                );
            } catch (error) {}
        },
    },
    async mounted() {
        await this.$store.dispatch(
            "partner/getPartnerConfigAction",
            this.$route.params.id,
        );
        const data = this.partnerConfig.reviewRatingPrefrencess;
        this.reviewApproval = data.reviewApproval;
        this.foulLanguage = data.foulLanguage;
        this.expiryDays = data.reviewExpiryDay;
        for (const obj of this.notificationMethods) {
            obj.enabled = data.reviewNotification[obj.id];
        }
    },
};
</script>

<style scoped>
.rating-review-preference {
    border-radius: 0.5rem;
}
.rating-review-preference .b-card-body {
    padding: 1.5rem;
}
.card-height {
    height: 39px;
}
</style>
